import React from 'react';
import { FormRenderProps } from 'react-final-form';
import { CloseButton } from '../button/CloseButton';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { List } from '../list/List';
import { ListItem } from '../list/ListItem';
import { Card } from '../card/Card';
import { Block } from '../block/Block';
import { DialogFooter } from '../dialog/DialogFooter';
import { ButtonToolbar } from '../button-toolbar/ButtonToolbar';
import { Button } from '../button/Button';
import { modalFormDialog } from '../form/utils';
import { SavedFiltersType } from './types';
import { ModalComponentProps } from '../modal/ModalManager';

type FormValues = {
  filtersToKeep: SavedFiltersType[];
};
type Props = {
  savedFilters?: SavedFiltersType[];
  formRenderProps: FormRenderProps<FormValues>;
} & ModalComponentProps;

const RemoveSavedFiltersModal: React.FC<Props> = ({
  formRenderProps: {
    handleSubmit,
    submitting,
    values,
    form: { change },
  },
  savedFilters,
  onClose,
}) => {
  const handleCheck = (value: SavedFiltersType): void => {
    let filtersToKeep: SavedFiltersType[] = values.filtersToKeep
      ? [...values.filtersToKeep]
      : [];

    if (
      filtersToKeep.some(
        (item: SavedFiltersType): boolean => item.id === value.id
      )
    ) {
      filtersToKeep = filtersToKeep.filter(
        (item: SavedFiltersType): boolean => item.id !== value.id
      );
    } else {
      filtersToKeep.push(value);
    }

    change('filtersToKeep', filtersToKeep);
  };

  return (
    <Dialog onClose={onClose} title="Odstranit filtry">
      <DialogBody>
        {savedFilters?.length ? (
          <List compact mode={'input'}>
            {savedFilters?.map((item: SavedFiltersType) => (
              <ListItem
                checkable
                checked={
                  !values.filtersToKeep?.some(
                    (itemToKeep: SavedFiltersType): boolean =>
                      itemToKeep.id === item.id
                  )
                }
                onCheck={() => handleCheck(item)}
                key={item.id}
                title={item.nazev}
                rowCheck
              />
            ))}
          </List>
        ) : (
          <Card mode="edit">
            <Block>Pro vyhledávání nejsou uloženy žádné filtery</Block>
          </Card>
        )}
      </DialogBody>
      <DialogFooter>
        <ButtonToolbar>
          <CloseButton disabled={submitting} onClick={onClose}>
            Zrušit
          </CloseButton>
          <Button
            style={'primary'}
            disabled={submitting}
            onClick={handleSubmit}
            dataTest={'submit'}
          >
            Odstranit
          </Button>
        </ButtonToolbar>
      </DialogFooter>
    </Dialog>
  );
};

export const RemoveSavedFiltersModalForm = modalFormDialog<FormValues, Props>(
  RemoveSavedFiltersModal
);
